angular.module("acl.storyboard.visualization", [
  "acl.visualizer.charts",
  "acl.visualizer.charts.backend",
  "acl.visualizer.model.chart",
  "acl.visualizer.model.table",
]);
